module.exports = __webpack_public_path__ + "static/media/Earth_Zoom_In.0a223b4a.mov";